<template>
  <div class="admin-cell-multiselect" :style="containerStyles">
    <AdminInputMultiselect
      v-bind="{ ...$attrs, ...$props }"
      @change="save"
      :is-focused="isFocused"
      @keydown.esc="isFocused = false"
      @blur="isFocused = false"
      @focus="isFocused = true"
    />
  </div>
</template>

<script>
import { Model } from '@vuex-orm/core'
import AdminInputMultiselect from '@/components/AdminInputMultiselect'
export default {
  name: 'AdminCellMultiselect',
  components: { AdminInputMultiselect },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    width: {
      type: [String, Number],
      default: null,
    },
    Model: {
      type: Model,
      default: () => Model,
    },
    fieldName: {
      type: String,
      require: true,
    },
    id: {
      type: [String, Number],
      require: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isFocused: false,
    }
  },
  computed: {
    containerStyles() {
      let maxWidth =
        typeof this.width === 'number' ? `${this.width}px` : this.width
      return {
        maxWidth,
      }
    }, // containerStyles
  },
  methods: {
    save(theSelections) {
      if ('function' === typeof this.Model.updateModel) {
        if (this.value == theSelections) return
        const fields = { [this.fieldName]: theSelections }
        this.Model.updateModel(this.id, fields)
      }
    }, // save
  },
}
</script>

<style scoped>
.placeholder-container {
  cursor: pointer;
}
.truncate {
  height: auto;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
